import { article as articleData } from "~/data";

export const checkIsPhotoEssayArticle = (articleTypeIds: OrUndefined<string>[]) =>
  articleTypeIds?.some(id => id === articleData.types.photoEssay.entityId) ?? false;
